var map = {
	"./de-DE": [
		66001
	],
	"./de-DE.ts": [
		66001
	],
	"./en-US": [
		16662
	],
	"./en-US.ts": [
		16662
	],
	"./fr-FR": [
		74179
	],
	"./fr-FR.ts": [
		74179
	],
	"./translations": [
		49734,
		9929
	],
	"./translations.ts": [
		49734,
		9929
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 81116;
module.exports = webpackAsyncContext;